module.exports = __webpack_public_path__ + "static/media/favicon.90a19ab0.ico";